import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class LEPartnerService extends ServiceBase {

  public findUserByNameAndAgency(agencyId: string, searchString: string): Observable<ServerModels.ENESS_LEPartnerDTO[]> {
    let options = {
      params: {
        'agencyId': agencyId,
        'searchString': searchString
      },
      headers: this.httpOptions.headers
    };

    return this.http.get<ServerModels.ENESS_LEPartnerDTO[]>(`${this.apiRoot}/api/LEPartner/FindUserByNameAndAgency`, options)
      .pipe(catchError(this.throwError<any>('findUserByNameAndAgency', null, null, null)));
  }

  public getLEPartnerByAgencyId(agencyId: string): Observable<ServerModels.ENESS_LEPartnerDTO[]> {
    let options = {
      params: {
        'agencyId': agencyId
      },
      headers: this.httpOptions.headers
    };
    return this.http.get<ServerModels.ENESS_LEPartnerDTO[]>(`${this.apiRoot}/api/LEPartner/GetLEPartnersByAgency`, options)
      .pipe(catchError(this.throwError<any>('getLEPartnerByAgencyId', null, null, null)));
  }

  public updatePartnerDTO(partnerDto: ServerModels.ENESS_LEPartnerDTO): Observable<ServerModels.ENESS_LEPartner> {
    return this.http.post<ServerModels.ENESS_LEPartner>(`${this.apiRoot}/api/LEPartner/UpdateLEPartnerDTO`, partnerDto, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('updatePartnerDTO', 'lePartnerFormMsg', null, null))); 
  }

  public addOrUpdateLEPartnerStagingAsync(lePartner: ServerModels.ENESS_LEPartnerDTO): Observable<ServerModels.ENESS_LEPartnerDTO> {
    return this.http.post<ServerModels.ENESS_LEPartnerDTO>(`${this.apiRoot}/api/LEPartner/AddOrUpdateLEPartnerStagingAsync`, lePartner, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('addOrUpdateLEPartnerStagingAsync', 'defaultMsg', null, null))); 
  }

  public getLEPartnerById(lePartnerId: string): Observable<ServerModels.ENESS_LEPartnerDTO> {
    let options = {
      params: {
        'lePartnerId': lePartnerId
      },
      headers: this.httpOptions.headers
    };
    return this.http.get<ServerModels.ENESS_LEPartnerDTO>(`${this.apiRoot}/api/LEPartner/GetLEPartnerById`, options)
      .pipe(catchError(this.swallowError<any>('getLEPartnerById', 'defaultMsg', null, null))); 
  }

  public getLEPartnerStagingById(partnerStagingId: string): Observable<ServerModels.ENESS_LEPartnerDTO> {
    let options = {
      params: {
        'partnerStagingId': partnerStagingId
      },
      headers: this.httpOptions.headers
    };
    return this.http.get<ServerModels.ENESS_LEPartnerDTO>(`${this.apiRoot}/api/LEPartner/GetLEPartnerStagingById`, options)
      .pipe(catchError(this.throwError<any>('getLEPartnerStagingById', null, null, null)));
  }

  public createEmptyLEPartner(): ServerModels.ENESS_LEPartnerDTO {
    return <ServerModels.ENESS_LEPartnerDTO>{
      LEPartnerStagingID: null,
      LEPartnerID: null,
      AgencyID: '',
      ApplicationUserID: null,
      Badge: null,
      ENESS_REF_Agency: null,
      FirstName: null,
      MiddleName: null,
      LastName: null,
      Suffix: null,
      Title: null,
      ENESS_XREF_LEPartnersPhoneNumbers: [],
      ENESS_XREF_LEPartnersEmailAccounts: []
    };
  }
}
